import { render, staticRenderFns } from "./SignatureBuilder.vue?vue&type=template&id=2720a285&scoped=true"
import script from "./SignatureBuilder.vue?vue&type=script&lang=js"
export * from "./SignatureBuilder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2720a285",
  null
  
)

export default component.exports